import request from '@/axios/customerConsultant'

// 12-获取小区
export function getVillageList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getVillageList',
    method: 'post',
    data
  })
}

// A-11-(rad1)创建需求邀请
export function addDemandInvite(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/manager/addDemandInvite',
    method: 'post',
    data
  })
}

// (rad1)-06-邀请涵详情
export function getInviteInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/rad_one/getInviteInfo',
    method: 'post',
    data
  })
}
